import * as React from 'react';
import * as connectWithStravaImage from './btn_strava_connectwith_orange.svg';

export default () => (
    <a href="/strava/authorize" className="strava-login-button">
        <img
            src={connectWithStravaImage}
            width="193"
            height="48"
            alt="Connect with Strava"
        />
    </a>
);



// WEBPACK FOOTER //
// ./src/client/components/Strava/StravaLoginButton.tsx